import { useMutation } from '@libs/use';

import * as API from '../requests';

type UseUpdateSymbolBrokerRequestQueryParamsType = {
  onReject?: (...arg: any[]) => void;
  onSuccess?: (...arg: any[]) => void;
};

function changeBrokerRequestFactory(instrumentIsin: string) {
  return {
    isins: [instrumentIsin],
    attachment: null,
    tag: 3, // helium
  };
}

export default function useUpdateSymbolBrokerRequestQuery({
  onReject,
  onSuccess,
}: UseUpdateSymbolBrokerRequestQueryParamsType) {
  const {
    execute: updateSymbolBrokerChangeRequest,
    isPending: isUpdatingSymbolBrokerRequest,
    isSuccess: isSuccessSymbolBrokerRequest,
    ...query
  } = useMutation(
    (instrumentIsin: string) =>
      API.updateSymbolBrokerRequest(changeBrokerRequestFactory(instrumentIsin)),
    {
      onSuccess,
      onReject,
    }
  );

  return {
    updateSymbolBrokerChangeRequest,
    isUpdatingSymbolBrokerRequest,
    isSuccessSymbolBrokerRequest,
    ...query,
  };
}
